'use strict';

const toggleNavSearch = $ => {
	const toggle = ( isExpanded ) => {
		if ( isExpanded ) {
			close();
		} else {
			open();
		}
	};

	const open = () => {
		$( '[data-search-input]' ).attr( 'tabindex', '0' ).focus();

		$( '[data-navbar-search] [data-search-collapse]' ).animate( {
			width: '195px'
		}, 400, function() {
			$( '[data-search-toggle]' ).attr( 'aria-expanded', 'true' );
		} );
	};

	const close = () => {
		$( '[data-search-input]' ).attr( 'tabindex', '-1' );

		$( '[data-navbar-search] [data-search-collapse]' ).animate( {
			width: '0px'
		}, 400, function() {
			$( '[data-search-toggle]' ).attr( 'aria-expanded', 'false' );
		} );
	};

	return {
		bind() {
			$( '[data-search-toggle]' ).on( 'click', e => {
				toggle( JSON.parse( $( e.currentTarget ).attr( 'aria-expanded' ) ) );
			} );
		}
	};
};

toggleNavSearch( jQuery ).bind();

const typewriterText = $ => {
	const breakpoint = 768;
	let lastWidth = window.innerWidth;
	let $typewriter = null;
	let $currentEl = null;
	let wordToType = '';
	let currentLetterIndex = 0;
	let animate = false;

	const init = ( ) => {
		const $words = $typewriter.children();

		animate = true;

		$typewriter.addClass( 'animate' );

		$words.each( ( i, el ) => {
			$( el ).data( 'word', $( el ).text() );
		} );

		$words.addClass( 'inactive-element' );
		$words.last().removeClass( 'inactive-element' ).addClass( 'active-element' );
		$currentEl = $typewriter.find( '.active-element' );
		typeNextWord();
	};

	const destroy = () => {
		$currentEl = null;
		wordToType = '';
		currentLetterIndex = 0;
		animate = false;

		$typewriter.removeClass( 'animate' );

		const $words = $typewriter.children();

		$words
			.removeClass( 'inactive-element active-element' )
			.each( ( i, el ) => {
				$( el ).text( $( el ).data( 'word' ) );
			} );
	};

	const typeNextWord = () => {
		if ( ! animate ) {
			return;
		}

		let $nextWord = $currentEl.next();

		if ( ! $nextWord.length ) {
			$nextWord = $typewriter.children().first();
		}

		$currentEl.removeClass( 'active-element' ).addClass( 'inactive-element' );
		$nextWord.addClass( 'active-element' ).removeClass( 'inactive-element' );
		$currentEl = $nextWord;

		wordToType = $currentEl.text();
		currentLetterIndex = 0;
		$currentEl.text( '' );
		type();
	};

	const type = () => {
		if ( ! animate ) {
			return;
		}

		if ( currentLetterIndex < wordToType.length ) {
			const nextSpelling = $currentEl.text() + wordToType.charAt( currentLetterIndex );
			$currentEl.text( nextSpelling );
			currentLetterIndex++;
			setTimeout( type, 150 );
		} else {
			setTimeout( typeNextWord, 400 );
		}
	};

	const resize = () => {
		const currentWidth = window.innerWidth;
		const expanding = currentWidth > lastWidth ? true : false;
		let crossBreakpoint = false;

		if ( expanding && currentWidth >= breakpoint && lastWidth < breakpoint ) {
			crossBreakpoint = true;
		}

		if ( ! expanding && currentWidth < breakpoint && lastWidth >= breakpoint ) {
			crossBreakpoint = true;
		}

		if ( expanding && crossBreakpoint ) {
			destroy();
		}

		if ( ! expanding && crossBreakpoint ) {
			init();
		}

		lastWidth = currentWidth;
	};

	return {
		bind() {
			$typewriter = $( '[data-typewriter]' );

			if ( $typewriter.length !== 1 ) {
				return;
			}

			init();

			// if ( lastWidth < breakpoint ) {
			// 	init();
			// }

			// $( window ).resize( resize );
		}
	};
};

typewriterText( jQuery ).bind();

const pageAnimations = $ => {
	let windowScrollPos = $( window ).scrollTop();
	let windowHeight = $( window ).height();

	const animate = () => {
		$( '[data-animatable]' ).each( function() {
			if ( $( this ).data( 'animatable' ) === 'completed' ) {
				return;
			}

			const position = $( this ).offset().top;

			if ( windowScrollPos + windowHeight > position ) {
				$( this ).addClass( 'animated' ).data( 'animatable', 'completed' );
			}
		} );
	};

	return {
		init() {
			animate();
			this.bind();
		},
		bind() {
			if ( $( 'body' ).hasClass( 'has-animations' ) ) {
				$( window ).on( 'resize scroll', () => {
					windowScrollPos = $( window ).scrollTop();
					windowHeight = $( window ).height();
					animate();
				} );
			}
		}
	};
};

pageAnimations( jQuery ).init();
